// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 759 ? "latex-linter-worker" : chunkId) + "." + {"225":"7bd68e34","759":"fe7caec4"}[chunkId] + ".chunk.js";
};